import { Divider } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const CustomDivider = withStyles(() => ({
  root: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
}))(Divider)

export default CustomDivider
